import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { API_BASE_URL_OR_PROD } from '../utils/apiBaseUrl';

const useStrapi = (route) => {
  const [loading, setLoading] = useState(true);
  const [elements, setElements] = useState(false);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL_OR_PROD}/autodiags/${route}`,
        );
        const data = await response.json();
        if (!cancelled) {
          setElements(data);
        }
      } catch (e) {
        // Network failures (offline, request cancelled by navigation, etc.)
        // must not become an unhandled rejection — surfaces on iOS Safari as
        // "TypeError: Load failed" (Sentry ROULEZJEUNESSE-FRONT-6).
        if (!cancelled) {
          Sentry.captureException(e);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [route]);

  return [loading, elements];
};

export default useStrapi;
